module.exports = __webpack_public_path__ + "img/RScorpio64_ua.8de062f4.webp";